import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { BorderouService } from '../borderou.service';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
    selector: 'app-view-borderou',
    templateUrl: './view-borderou.component.html',
    styleUrls: ['./view-borderou.component.scss'],
})
export class ViewBorderouComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading: boolean = false;

    borderouId!: number;
    borderouInfo: any;
    borderouRecords: any[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            borderouId: number,
        },
        private dialogRef: MatDialogRef<ViewBorderouComponent>,
        private borderouService: BorderouService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
    ) {
        this.borderouId = data.borderouId;
    }

    ngOnInit() {
        this.loadBorderouData();
    }

    loadBorderouData() {
        this.isLoading = true;
        this.borderouService
            .view(this.borderouId)
            .pipe(
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results: any) => {
                    this.borderouInfo = results.data.info;
                    this.borderouRecords = results.data.records;
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }
}
